/* eslint-disable */
/**
 * `land/era-details/*` — empire era details modal (`EmpirePeriodDetailsPanel`) + tech tree panel bg / era icons
 * (`technology-research-page.tsx`). Keep filenames in sync with those modules.
 */
const B = 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/land/era-details'

/** Deduplicated absolute URLs for `VERCEL_BLOB_PRELOAD_PRIORITIZED` (not assetWarmup). */
export const ERA_DETAILS_BLOB_PRELOAD_URLS: readonly string[] = [
  `${B}/allian_icon.webp`,
  `${B}/alliance_right_icon.webp`,
  `${B}/battle_lost_icon.webp`,
  `${B}/battle_win_icon.webp`,
  `${B}/buildings_btn.webp`,
  `${B}/castle_flag_icon.webp`,
  `${B}/castle_icon.webp`,
  `${B}/character_icon.webp`,
  `${B}/close_btn.webp`,
  `${B}/era_bg.webp`,
  `${B}/high_kingdom_era.webp`,
  `${B}/imperial_era.webp`,
  `${B}/kingdom_era.webp`,
  `${B}/logo_bg.webp`,
  `${B}/palace_flag_icon.webp`,
  `${B}/power_icon.webp`,
  `${B}/prosperity_icon.webp`,
  `${B}/settler_era.webp`,
  `${B}/survival_era.webp`,
  `${B}/technologies_btn.webp`,
  `${B}/troops_icon.webp`,
  `${B}/win_streak_icon.webp`,
]
